import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useMemo, useState, useRef } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { BarLoader, ClockLoader, GridLoader } from "react-spinners";
import { MenuContext } from "../context/MenuContext";
import { TbHistoryToggle, TbPigMoney } from "react-icons/tb";
import { BiMoneyWithdraw } from "react-icons/bi";
import { TopBar } from "../components/topbar";
import { IoIosSearch } from "react-icons/io";
import { FaPlaneArrival, FaPlaneDeparture, FaPlaneSlash } from "react-icons/fa";
import { MdAirplanemodeActive } from "react-icons/md";
import { TostMessageContext } from "../context/TostMessage";
import { BellIcon, PinIcon, CloudOffIcon, AirportField, Icon, ToggleButton, FleetCard, Tab, ActionLink, StatusPill, PagerBtn } from "../components/icons";
import { FaPeopleGroup } from "react-icons/fa6";
import { CharterNote } from "../components/add_charter_note";

const getPaginationItems = (page, totalPages, windowSize = 2) => {
  // windowSize=2 => shows 2 pages on each side of current
  const items = [];
  if (totalPages <= 1) return [1];

  const start = Math.max(2, page - windowSize);
  const end = Math.min(totalPages - 1, page + windowSize);

  items.push(1);

  if (start > 2) items.push("...");

  for (let p = start; p <= end; p++) items.push(p);

  if (end < totalPages - 1) items.push("...");

  if (totalPages > 1) items.push(totalPages);

  return items;
};

export default function MyFlights() {
    const [cookies] = useCookies();
    const [loading, setLoading] = useState(false);
    const [buttonLoading, setButtonLoading] = useState(false);
    const navigate = useNavigate();
    const {setTostMessage, userProfile} = useContext(TostMessageContext);
    const [pageData, setPageData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const tabs = ["CHARTERED", "SHARED"];
    const [tab, setTab] = useState("CHARTERED"); // ALL | CHARTERED | SHARED
    const [page, setPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    const [tableData, setTableData] = useState([]);
    
    useEffect(() => {
        setTableData([]);
        getData();
    }, [tab])
    useEffect(() => {
        getData();
    }, [page])

    const getData = async () => {
        const postData = new FormData();
        postData.append('type', tab);
        postData.append('page', page)
        setLoading(true);
        try {
            const response = await axios.post(base_url + '/my-flights/get-data.php', postData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                },
            });
            if (response.data.status) {
                setLoading(false);
                setTableData(response.data.data)
                setTotalPages(response.data.totalPages)
                setTotalRecords(response.data.total)
            } else {
                setTostMessage({
                    messageType: 'error',
                    message: response.data.message
                })
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            setTostMessage({
                messageType: 'error',
                message: 'Network Error'
            })
        }
    }
    const items = getPaginationItems(page, totalPages, 2);
    return(
        <div className="w-full h-full">
            <TopBar />
            {loading && (
                <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] fixed">
                    <ClockLoader
                        color={'#d8b05a'}
                        loading={true}
                        size={40}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                    />
                </div>
            )}
            <div className="w-full p-4 sm:p-6">
                <div>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="text-xl text-white/90">
                            <p className="font-semibold">
                                Flight History
                            </p>
                            <p className="mt-2 text-sm text-white/50">
                                Review your past journeys and manage your travel documents.
                            </p>
                        </div>
                    </div>
                    <div className="mt-10 mx-auto w-full max-w-6xl">
                        {/* Tabs */}
                        <div className="my-2 flex items-center gap-8">
                            <Tab active={tab === "CHARTERED"} onClick={() => setTab("CHARTERED")}>
                                CHARTERED
                            </Tab>
                            <Tab active={tab === "SHARED"} onClick={() => setTab("SHARED")}>
                                SCHEDULED
                            </Tab>
                        </div>
                        <div className="mt-3 h-px w-full bg-white/10" />

                        {/* Table Card */}
                        <div className="relative mt-6 overflow-hidden rounded-3xl border border-[#40392B]">

                        <div className="relative">
                            {/* Desktop header */}
                            {tab == "SHARED" ?
                            <div className="hidden sm:grid grid-cols-12 gap-3 border-b border-white/10 bg-[#C59F59]/10 px-6 py-4 text-[11px] font-semibold tracking-[0.28em] text-[#d8b05a]/70">
                                <div className="col-span-2">DATE</div>
                                <div className="col-span-2">REFERENCE</div>
                                <div className="col-span-2">ROUTE</div>
                                <div className="col-span-2">DURATION</div>
                                <div className="col-span-2">STATUS</div>
                                <div className="col-span-2 text-right">ACTIONS</div>
                            </div>
                            :
                            <div className="hidden sm:grid grid-cols-12 gap-3 border-b border-white/10 bg-[#C59F59]/10 px-6 py-4 text-[11px] font-semibold tracking-[0.28em] text-[#d8b05a]/70">
                                <div className="col-span-2">DATE</div>
                                <div className="col-span-2">DEPARTURE</div>
                                <div className="col-span-2">ROUTE</div>
                                <div className="col-span-2">CONTACT PERSON</div>
                                <div className="col-span-2">STATUS</div>
                                <div className="col-span-2 text-right">ACTIONS</div>
                            </div>
                            }

                            {/* Rows */}
                            <div className="divide-y divide-white/10">
                            {tableData?.map((row, idx) => (
                                <div key={idx} className="px-5 py-5 sm:px-6">
                                {/* Mobile layout */}
                                {tab == "SHARED" ?
                                <div className="sm:hidden space-y-3">
                                    <div className="flex items-start justify-between gap-3">
                                    <div className="min-w-0">
                                        <div className="text-sm text-white/60">{row.flight_date}</div>
                                        <div className="mt-1 text-base font-semibold text-white/90">
                                        {row.booking_reference}
                                        </div>
                                        <div className="mt-1 text-sm font-semibold text-white/80">
                                        {row.route}
                                        </div>
                                        <div className="mt-1 text-base font-semibold text-white/90">
                                        {row.duration}
                                        </div>
                                    </div>
                                    <ActionLink onClick={() => navigate(`/dashboard/my-flights/${tab}/${row.booking_reference}`, {state: {row}})}>
                                        Booking Confirmation
                                    </ActionLink>
                                    </div>
                                    <div>
                                    <StatusPill status={row.status} />
                                    </div>
                                </div>
                                :
                                <div className="sm:hidden space-y-3">
                                    <div className="flex items-start justify-between gap-3">
                                    <div className="min-w-0">
                                        <div className="text-sm text-white/60">{row.flight_date}</div>
                                        <div className="mt-1 text-base font-semibold text-white/90">
                                        {row.pref_departure_airport_name}
                                        </div>
                                        <div className="mt-1 text-sm font-semibold text-white/80">
                                        {row.route}
                                        </div>
                                        <div className="mt-1 text-base font-semibold text-white/90">
                                        {row.contact_name}{", "}{row.contact_phone}{" "}{row.contact_email}
                                        </div>
                                    </div>
                                    <ActionLink onClick={() => navigate(`/dashboard/my-flights/${tab}/${row.booking_reference}`, {state: {row}})}>
                                        Manage Charter
                                    </ActionLink>
                                    </div>
                                    <div>
                                    <StatusPill status={row.status} />
                                    </div>
                                </div>
                                }

                                {/* Desktop layout */}
                                {tab == "SHARED" ?
                                <div className="hidden sm:grid grid-cols-12 gap-3 items-center">
                                    <div className="col-span-2 text-sm text-white/60">{row.flight_date}</div>
                                    <div className="col-span-2 text-sm font-semibold text-white/90">{row.booking_reference}</div>
                                    <div className="col-span-2 text-sm font-semibold text-white/80">{row.route}</div>
                                    <div className="col-span-2 text-sm font-semibold text-white/90">{row.duration}</div>
                                    <div className="col-span-2">
                                    <StatusPill status={row.status} />
                                    </div>
                                    <div className="col-span-2 text-right">
                                    <ActionLink onClick={() => navigate(`/dashboard/my-flights/${tab}/${row.booking_reference}`, {state: {row}})}>Booking Confirmation</ActionLink>
                                    </div>
                                </div>
                                :
                                <div className="hidden sm:grid grid-cols-12 gap-3 items-center">
                                    <div className="col-span-2 text-sm text-white/60">{row.flight_date}</div>
                                    <div className="col-span-2 text-sm font-semibold text-white/90">{row.pref_departure_airport_name}</div>
                                    <div className="col-span-2 text-sm font-semibold text-white/80">{row.route}</div>
                                    <div className="col-span-2 text-sm font-semibold text-white/90">{row.contact_name}{", "}{row.contact_phone}{" "}{row.contact_email}</div>
                                    <div className="col-span-2">
                                    <StatusPill status={row.status} />
                                    </div>
                                    <div className="col-span-2 text-right">
                                    <ActionLink onClick={() => navigate(`/dashboard/my-flights/${tab}/${row.booking_reference}`, {state: {row}})}>Manage Charter</ActionLink>
                                    </div>
                                </div>
                                }
                                </div>
                            ))}
                            </div>

                            {/* Footer */}
                            <div className="flex flex-col gap-4 border-t border-white/10 px-5 py-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
                            <div className="text-sm text-white/50">
                                Showing <span className="text-white/70">{tableData?.length}</span> of{" "}
                                <span className="text-white/70">{totalRecords}</span> flight(s)
                            </div>

                            <div className="flex items-center gap-2">
                                <PagerBtn
                                    icon="chevL"
                                    onClick={() => setPage((p) => Math.max(1, p - 1))}
                                />

                                {items.map((it, idx) =>
                                    it === "..." ? (
                                    <div
                                        key={`dots-${idx}`}
                                        className="grid h-9 w-9 place-items-center text-white/40"
                                    >
                                        …
                                    </div>
                                    ) : (
                                    <PagerBtn
                                        key={it}
                                        active={page === it}
                                        onClick={() => setPage(it)}
                                    >
                                        {it}
                                    </PagerBtn>
                                    )
                                )}

                                <PagerBtn
                                    icon="chevR"
                                    onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                                />
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}